// Minimal async_hooks stand-in for OpenTelemetry's context manager.
// Synchronous propagation only — good enough for the web build's telemetry,
// which is fused off at the exporter level anyway.
class AsyncLocalStorage {
    constructor() {
        this._store = undefined;
    }
    getStore() {
        return this._store;
    }
    run(store, fn, ...args) {
        const previous = this._store;
        this._store = store;
        try {
            return fn(...args);
        } finally {
            this._store = previous;
        }
    }
    exit(fn, ...args) {
        return this.run(undefined, fn, ...args);
    }
    enterWith(store) {
        this._store = store;
    }
    disable() {
        this._store = undefined;
    }
}

class AsyncResource {
    constructor(type) {
        this.type = type;
    }
    runInAsyncScope(fn, thisArg, ...args) {
        return fn.apply(thisArg, args);
    }
    emitDestroy() {}
    asyncId() {
        return 0;
    }
    static bind(fn) {
        return fn;
    }
}

module.exports = {
    AsyncLocalStorage,
    AsyncResource,
    createHook: () => ({ enable: () => undefined, disable: () => undefined }),
    executionAsyncId: () => 0,
    triggerAsyncId: () => 0,
};
